export const OnboardingLanding = () => {
    return <div>
        <b>Notice:</b> Streck PVS kits and the PVS application service are discontinued as of <b>March 31, 2026</b>. <br></br>
        Kits received by <b>March 31, 2026</b> will be processed, and PVS reports will remain accessible through <b>December 31, 2026</b>. <br></br>
        For questions, contact the Streck STATS department at <b>800-898-9563</b>.
    </div>;
}

export const OnboardingThanks = () => {
    return <div>
        Thank you for joining us!<br /><br />
        You are now ready to submit a kit.<br /><br />
        To simplify this process, we recommend adding operators and pipettes to the lab. This can be done by clicking the "operators" or "pipets" tab in the navigation column on the left-hand side and entering the necessary information.<br /><br />
        Detailed video tutorials and additional instructions can be found under the FAQ tab.
    </div>;
}